<template>
  <div class="printAffirmOrderBox">
    <div class="shopCarTop">
      <div style="margin-top: 15px" class="shopCarTopSearch">
        <p class="shopCarText">经销商订货单</p>
      </div>
      <p class="shopNum">
        全部商品
        <span>1</span>
      </p>
    </div>
    <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="70"
        class="demo-ruleForm"
    >
      <div class="orderInformation">
        <ul class="tableHeader">
<!--          <li class="select">
            <el-checkbox
                :indeterminate="isIndeterminate"
                @change="handleCheckAllChange"
                v-model="checkAll"
            >全选
            </el-checkbox>
          </li>-->
          <li class="modelFile">产品图片</li>
          <li class="name">产品名称</li>
          <li class="printInfo">规格</li>
          <li class="price">数量</li>
          <li class="jfDate">交付日期</li>
          <li class="facilitator">订货方式</li>
<!--          <li class="printNum">操作</li>-->
        </ul>
        <ul class="tableContent">
          <li v-for="(item, index) in ruleForm.shopUserList" :key="index">
            <div class="flex-center tableContent_mesg">
<!--              <el-checkbox
                  v-model="item.checked"
                  class="select"
                  @change="handleCheckedCitiesChange"
              ></el-checkbox>-->
              <div class="modelFile">
                <div class="modelImg">
                  <img :src="item.imgUrl" v-if="item.imgUrl"/>
                </div>
              </div>
               <div class="brandBox name" @click="handGoodsDetails(item.productSpecUuid)">
                  <p>{{ item.productName }}</p>
                </div>
              <div class="printInfo">
                <div>{{ item.specName }}</div>
              </div>
              <div class="price">
                <el-form-item style="width: 134px;margin: 0 auto;" :prop="'shopUserList.'+index+'.orderNum'" :rules="[{required: true, message: '请填写数量', trigger: 'blur'}]">
                  <el-input-number
                      style="width: 134px;"
                      v-model="item.orderNum"
                      @change="getTranslationInfo"
                      :min="1"
                  ></el-input-number>
                </el-form-item>
              </div>
              <div class="jfDate">
                <el-form-item :prop="'shopUserList.'+index+'.deliveryDate'" :rules="[{required: true, message: '请选择交付日期', trigger: 'change'}]">
                  <el-date-picker
                      v-model="item.deliveryDate"
                      value-format="yyyy-MM-dd"
                      style="width: 140px"
                      type="date"
                      placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
              <div class="facilitator">
                <el-form-item :prop="'shopUserList.'+index+'.orderingMethodUuid'" :rules="[{required: true, message: '请选择订货方式', trigger: 'change'}]">
                  <el-select
                      v-model="item.orderingMethodUuid"
                      filterable
                      placeholder="请选择"
                      style="width: 120px"
                  >
                    <el-option
                        v-for="item in options"
                        :key="item.uuid"
                        :label="item.name"
                        :value="item.uuid"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
<!--              <div class="printNum">
                <el-button type="text" @click="delSpecList(item.uuid, index)"
                >删除
                </el-button
                >
              </div>-->
            </div>
            <div class="flex-center other">
              <el-form-item label="备注">
                <el-input
                    v-model="item.remark"
                    type="textarea"
                    style="width: 420px; margin-right: 20px"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-upload
                    class="avatar-uploader"
                    action="/service-center/upload/file/single"
                    :file-list="fileList"
                    :limit="5"
                    accept=".jpg,.jpeg,.png,.xlsx , .xls ,.docx,.dox,.pdf, .txt,.pptx , .JPG,.JPEG,.PBG,.GIF,.BMP,.PDF,.XLSX,.XLS ,.DOCX,.DOX ,.TXT , .PPTX"
                    :on-remove="(res,file)=>{
                      return handleRemoveFile(res,file,item);
                    }"
                    :on-error="handleFileError"
                    :on-success="(res,file)=>{
                      return handleFileSuccess(res,file,item);
                    }"
                >
                  <el-button size="small" type="text">上传附件</el-button>
                </el-upload>
              </el-form-item>
            </div>
          </li>
        </ul>
      </div>
      <div class="addressInformation">
        <div class="title">
          <div class="titleLeft">收货信息</div>
        </div>
        <div class="addressList">
          <div :class="item.checked?'active addressItem':'addressItem'" v-for="(item,index) in addressList" :key="index">
            <el-checkbox class="checkBox" v-model="item.checked" @change="addressChecked(item)"></el-checkbox>
            <div class="name">{{ item.receiverName }}
              <el-button v-if="item.checked" type="text" icon="el-icon-edit"
                        style="padding: 0;position: relative;z-index: 9;" @click="toEditAddress(item)"></el-button>
            </div>
            <div class="tel">{{ item.mobile }}</div>
            <div class="address">{{ item.province }}{{ item.city }}{{ item.district }}{{ item.areaInfo }}</div>
            <img v-if="item.checked" src="@/assets/addressBorder.png" class="addressBorder">
          </div>
          <div class="addressItem addItem" @click="toDeliveryAddress">
            <div class="icon"><i class="el-icon-plus"></i></div>
            <div class="addName">新增地址</div>
          </div>
        </div>
      </div>
      <div class="toAffirmOrder">
        <div class="buttonGroup">
          <div class="flex-center buttonGroup_left">
<!--            <el-checkbox
                v-model="checkAll"
                @change="handleCheckAllChange"
                :indeterminate="isIndeterminate"
            >全选
            </el-checkbox>-->
<!--            <p class="del" @click="deleteCheckedGood">删除选中的商品</p>-->
          </div>
          <div class="flex-center buttonGroup_right">
<!--            <p class="closse">已选中{{ totalNum }}件商品</p>-->
            <el-button type="primary" @click="submitOrder('ruleForm')">提交订单</el-button>
          </div>
        </div>
      </div>
    </el-form>

    <!--新增/编辑地址-->
    <delivery-address-dialog ref="deliveryAddressDialogRef" @address="deliveryAddress"></delivery-address-dialog>
  </div>
</template>

<script>
import {getAddressList, getDictionaryItem} from "../../utils/interface";
import deliveryAddressDialog from "../print/deliveryAddressDialog.vue";
import {submitProductOrder} from "../../utils/product";

export default {
  name: "productOrderPage",
  components: {deliveryAddressDialog},
  data() {
    return {
      ruleForm: {
        shopUserList: [],
        receiveAddressUuid: '',
      },
      fileList: [],
      orderSearch: "",
      dialogVisible: false,
      printNotice: "",
      multipleSelection: [],
      isIndeterminate: true,
      totalNum: 0,
      addressList: [],
      options: [],
      checkAll: false,
      rules: {
        receiveAddressUuid: [{required: true, message: '请选择收货地址', trigger: "blur"}],
      },
    };
  },
  created() {
    this.getAddressList();
    this.getOrderMethod();
    let formData = JSON.parse(window.sessionStorage.getItem("updateForm"));
    this.ruleForm.shopUserList=formData.map((item)=> {
      item.productOrderFileList=[];
      item.orderNum=1;
      item.deliveryDate = '';
      item.orderingMethodUuid = '';
      return item;
    });
  },
  methods: {
    getOrderMethod() {
      getDictionaryItem({groupCode: "ORDERING_METHOD"}).then(res => {
        this.options = res;
      });
    },
    // 获取地址
    getAddressList() {
      getAddressList().then((res) => {
        res.data.map(item => {
          if (item.defaultVal == 1) {
            item.checked = true;
            this.ruleForm.receiveAddressUuid = item.uuid;
          } else {
            item.checked = false;
          }
        });
        this.addressList = res.data;
      });
    },
    submitOrder(formName) {
      if (!this.ruleForm.receiveAddressUuid) {
        this.$message.warning('请选择收货地址!')
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          submitProductOrder({productList:this.ruleForm.shopUserList,receiveAddressUuid:this.ruleForm.receiveAddressUuid}).then(res => {
            if(res.success){
              this.$alert('订货单提交成功，前往买家中心查看','提示',{
                confirmButtonText: '确定',
                callback:this.toBuyerCenter
              });
            }else{
              this.$message.success("提交失败");
            }
          });
        } else {
          return false;
        }
      });
    },
    handGoodsDetails(uuid) {
      let routeData = this.$router.resolve({
        name: "productDetails",
        query: {
          uuid: uuid,
          typeCode: 'spec',
        },
      });
      window.open(routeData.href);
    },
    getTranslationInfo() {
    },
    toBuyerCenter(){
      location.href=this.$url.buyerWeb + "/#/providerInquiry";
    },
    // 删除
    delSpecList(uuid, index) {
      // 删除数据
      //   deleteShopCarInfo({shopCarUuid:item.uuid}).then((res)=>{
      //     if(res.success){
      //       this.$message.success("删除成功");
      //       this.getShopCarList();
      //     }
      //   });
    },
    deleteCheckedGood() {
      //   this.shopUserList.map(item=>{
      //     item.shopCarList.map(childItem => {
      //       if (childItem.checked) {
      //         deleteShopCarInfo({shopCarUuid:childItem.uuid}).then((res)=>{
      //           if(res.success){
      //             //this.$message.success("删除成功");
      //             this.getShopCarList();
      //           }
      //         });
      //       }
      //     })
      //   });
    },
    // 历史信息
    getHistoryList() {
    },
    handleCheckAllChange(val) {
      this.totalNum = 0;
      this.totalPrice = 0;
      this.checkAll=val;
      this.ruleForm.shopUserList.map(item=>{
        item.checked = this.val;
        this.totalNum++;
      });
    },
    handleCheckedCitiesChange() {
      this.multipleSelection = this.tableData.filter(
          (res) => res.checked === true
      );
      if (this.multipleSelection.length === this.tableData.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    // 模板附件
    handleFileSuccess(res, file,item) {
      item.productOrderFileList.push({url:res.url,name:res.name,uid:file.uid});
    },
    handleRemoveFile(file, fileList,item) {
      item.productOrderFileList = item.productOrderFileList.filter(f => f.uid != file.uid);
    },

    handleFileError(err, file, fileList) {
      this.$message.error(err);
    },
    // 地址选中事件
    addressChecked(val) {
      this.addressList.map(item=>{
        if(item.uuid === val.uuid){
          item.checked = val.checked;
        } else {
          item.checked = false
        }
      });
      this.ruleForm.receiveAddressUuid = val.uuid;
    },
    // 点击打开新增地址弹出框
    toDeliveryAddress() {
      this.$refs.deliveryAddressDialogRef.init('add')
    },
    // 点击打卡编辑地址弹出框
    toEditAddress(item) {
      this.$refs.deliveryAddressDialogRef.init('edit', item)
    },
    // 新增/修改地址
    deliveryAddress(val) {
      getAddressList().then((res) => {
        res.data.map(item => {
          if (val.uuid == item.uuid) {
            item.checked = true;
          } else {
            item.checked = false;
          }
        });
        this.addressList = res.data;
      });
    },
  },
};
</script>

<style scoped lang="less">
.flex {
  display: flex;
}

.flex-center {
  display: flex;
  align-items: center;
}

.flex-item-center {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/deep/ .el-form-item {
  display: flex;
}

/deep/ .el-form-item__label {
  flex-shrink: 0;
}

.printAffirmOrderBox {
  padding: 0 0 100px;
 .shopCarTop {
    width: 1200px;
    margin: 0 auto;
    .shopCarTopSearch {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .shopCarText {
        flex-shrink: 0;
        font-size: 20px;
        color: #009999;
        font-weight: 600;
      }
      .input-with-select .el-input-group__prepend {
        border: 1px solid #009999;
        background-color: #009999;
      }
      /deep/.el-input-group {
        width: 30%;
      }
      /deep/.el-input__inner {
        height: 33px;
        line-height: 33px;
        border: 1px solid #009999;
      }
      /deep/.el-input-group__append,
      .el-input-group__prepend {
        border: 1px solid #009999;
        background-color: #009999;
      }
      /deep/.el-button {
        color: #fff;
      }
    }
    .shopNum {
      margin: 26px 0 10px;
      color: #009999;
      cursor: pointer;
      font-family: tahoma, arial, Microsoft YaHei, Hiragino Sans GB;
    }
  }
  .addressInformation {
    width: 1200px;
    margin: 0 auto 20px;
    background: #fff;
    border-radius: 2px;

    .title {
      width: 100%;
      height: 47px;
      line-height: 55px;
      border-bottom: 1px solid #F0F0F0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      .titleLeft {
        font-size: 16px;
        font-weight: 500;
        color: #009999;
      }

      .titleRight {
        display: flex;

        button {
          margin-left: 50px;
        }
      }
    }

    .addressList {
      padding: 0 15px 0;
      display: flex;
      flex-wrap: wrap;

      .addressItem {
        padding: 14px 22px;
        margin-bottom: 24px;
        margin-right: 30px;
        position: relative;
        width: 270px;
        border-radius: 8px;
        border: 2px dashed #E3E3E3;
        font-size: 14px;

        .addressBorder {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }

        &.active {
          border: 2px dashed #fff;
        }

        // &:nth-of-type(4n) {
        //   margin-right: 0;
        // }

        .checkBox {
          position: absolute;
          right: 22px;
          top: 14px;
        }

        .name {
          color: #000;
        }

        .tel {
          color: rgba(51, 51, 51, 0.85);
          padding: 6px 0;
        }

        .address {
          color: rgba(51, 51, 51, 0.85);
          line-height: 22px;
        }
      }

      .addItem {
        text-align: center;
        cursor: pointer;
        color: #666;

        &:hover {
          border: 2px dashed #1890FF;
        }

        .icon {
          font-size: 30px;
        }

        .addName {
          font-size: 14px;
          padding-top: 5px;
        }
      }
    }
  }

  .top_title {
    width: 1200px;
    margin: 0 auto 20px;

    .titleLeft {
      font-weight: bold;
      color: #2d50a1;
      font-size: 20px;
    }

    .top_title_right {
      /deep/ .el-input__inner {
        border: 1px solid #2d50a1;
        border-radius: 4px 0 0 4px;
        width: 280px;
      }
    }
  }

  .title {
    width: 1200px;
    margin: 0 auto 10px;
    color: #2d50a1;
  }

  .orderInformation {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    border-radius: 2px;

    .tableHeader {
      box-sizing: border-box;
      display: flex;
      width: 100%;
      height: 35px;
      line-height: 35px;
      background: #eeeeee;
      margin: 0 0 15px;
      padding: 0 10px;
      //   padding: 10px 15px;

      li {
        text-align: center;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }
    }

    .tableContent {
      box-sizing: border-box;
      //display: flex;
      align-items: center;
      padding: 0 10px;
      font-size: 12px;

      li {
        width: 100%;
        border-bottom: 1px solid #efefef;
        padding-bottom: 15px;
        .tableContent_mesg {
          margin-bottom: 10px;
          padding-bottom: 10px;
        }

        .other {
          background: #a5e5e536;
          padding-top: 20px;
          padding-left: 20px;
        }
      }
        .brandBox {
          cursor: pointer;
        }

      .modelFile {
        display: flex;
        padding-right: 10px;
        align-items: center;
        
        .modelImg {
          width: 100%;
          position: relative;
          margin-right: 10px;
          text-align: center;
          //background: #000;
          

          &:hover {
            .model {
              display: block;
            }
          }

          img {
            width: 100px;
            height: 64px;
            border: 1px solid rgba(0, 0, 0, 0.15);
          }

          .model {
            position: absolute;
            left: 0;
            top: 0;
            width: 98px;
            height: 98px;
            background: rgba(0, 0, 0, 0.3);
            text-align: center;
            line-height: 94px;
            display: none;

            i {
              color: #fff;
              cursor: pointer;
              font-size: 20px;
            }
          }
        }

        .modelInfo {
          color: #666666;

          .modelName {
            color: #000000;
            font-size: 14px;
            padding-bottom: 12px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 195px;
          }

          .volume {
            padding: 9px 0;
          }
        }
      }

      .printInfo {
        display: flex;
        justify-content: center;

        .printInfoItem {
          display: flex;
          // justify-content: center;
          padding: 5px 0;

          .contentUi {
            text-align: left;

            li {
              width: 50%;
            }
          }

          .name {
            color: #737373;
            min-width: 80px;
            text-align: right;
          }

          .content {
            color: #000;

            ul {
              li {
                color: #409eff;
                cursor: pointer;
              }
            }
          }
        }
      }

      .facilitator {
        display: flex;
        justify-content: center;

        .facilitatorItem {
          display: flex;
          // justify-content: center;
          padding: 5px 0;

          .name {
            color: #737373;
            min-width: 100px;
            text-align: left;
          }

          .content {
            color: #000;
          }
        }
      }
    }

    .select {
      width: 60px;
    }

    .modelFile {
      flex: 1;
      text-align: center;
      align-items: center;
    }
    .name {
      width: 200px;
      text-align: center;
    }
    .printInfo {
      width: 180px;
      text-align: center;
      padding: 0 15px;
    }

    .facilitator {
      width: 150px;
      text-align: center;
      display: flex;
      justify-content: center;
      /deep/.el-form-item {
        margin-bottom: 0;
      }
    }

    .jfDate {
      width: 200px;
      text-align: center;
      display: flex;
      justify-content: center;
      /deep/.el-form-item {
        margin-bottom: 0;
      }
    }

    .price {
      width: 178px;
      text-align: center;
    }

    .printNum {
      width: 200px;
      text-align: center;
    }
  }

  .add_mesg {
    .title {
      border-bottom: 1px solid #2d50a1;
    }

    .formbox {
      width: 1200px;
      margin: 20px auto 0;
      display: grid;
      align-items: center;
      grid-template-columns: 200px 200px 200px 400px 120px;
      grid-column-gap: 16px;

      /deep/ .el-form-item__content {
        width: 100%;
      }
    }
  }

  .toAffirmOrder {
    width: 1200px;
    margin: 0 auto 20px;

    .freight {
      display: flex;
      justify-content: space-between;
      padding-bottom: 15px;
      margin-bottom: 15px;
      border-bottom: 1px solid #ddd;
    }

    .buttonGroup {
      display: flex;
      justify-content: space-between;
      margin-top: 60px;
      font-size: 14px;
      color: #737373;

      .del {
        cursor: pointer;
        margin-left: 30px;

        &:hover {
          color: #2d50a1;
        }
      }

      .closse {
        cursor: pointer;
      }

      button {
        margin-left: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/productOrderPage.vue